/**
 * @Description: 科三考场分类页面
 * @author ZhanFuzheng
 * @date 2022/11/07 11:29:01
*/
<template>
  <div :class="['wrapper']">
    <!--头部-->
    <template>
      <div class="header">
        <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
        <div class="header-main"></div>
        <div class="header-right"><img @click="pushCusService" src="@/assets/vip/icon_customerservice1@2x.png" alt=""></div>
      </div>
      <!--头部占位-->
      <div class="header-pre"></div>
    </template>

    <div class="category">
        <div class="tips">
            <img src="@/assets/examVideoV2/icon_wxtstb@2x.png">
            <p>温馨提示：购买考场视频后可查看您所选择的单个考场下包含的所有路线视频，请选择正确的考场进行购买哦~</p>
        </div>
        <div class="category-wrap">
            <h3>科三考场</h3>
            <p class="small">请选择您的考场</p>
            <div class="city">
                <div v-for="item in categoryItems" :key="item.cityCode" class="city-item" :class="{active: item.cityCode === currentCategory.cityCode}" @click="handleToggleCity(item.cityCode)"><span>{{item.cityName}}</span></div>
            </div>
            <div v-if="currentCategory && currentCategory.examPlaceList && currentCategory.examPlaceList.length" class="category-content">
                <div v-for="item in currentCategory.examPlaceList" :key="item.id" class="category-item" @click="handleToList(item)">
                    <img class="category-item__bg" :src="item.reduceUrl">
                    <div class="category-item__mask">
                        <div class="category-item__name">{{item.name}}</div>
                        <div class="category-item__line">共<span>{{item.count}}</span>条路线</div>
                        <img v-if="item.vipFlag || vipSwitchFlag" class="category-item__type" :src=" item.vipFlag ? require('@/assets/examVideoV2/icon_ykt@2x.png') : require('@/assets/examVideoV2/icon_wkt@2x.png')">
                    </div>
                </div>
            </div>
        </div>
        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" />
    </div>
  </div>
</template>

<script>
import dialog from '@/components/dialog/index.vue'
import { Toast } from 'vant'
export default {
    name: 'examThreeVideoV2Category',
    components: {
        ctlDialog: dialog
    },
    data () {
        return {
            cityCode: '',
            currentCategory: {},
            categoryItems: [],
            version: '',
            parentName: '',
            vipSwitchFlag: false,
            isOpenVip: false,
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    },
    methods: {
        init () {
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_ervip_classify_page' })
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')
            this.userInfo = userInfo ? JSON.parse(userInfo) : {}
            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')
            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }
            // 设置版本
            this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''
        },
        // 返回
        goBack () {
            const examPlaceBatchId = localStorage.getItem('examVideoV2PlaceBatchId')
            localStorage.removeItem('examVideoV2PlaceBatchId')
            // 开通过VIP 直接关闭页面 或者拿不到上级页面 跳回去
            if (this.isOpenVip || !this.parentName) {
                this.$jsBridge.callBackHandler('returnLastPage')
            } else {
                this.$router.replace({ name: this.parentName, query: { cityCode: this.cityCode, examPlaceBatchId } })
            }
        },
        // 联系客服
        pushCusService () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 跳转到考场视频列表页面
        handleToList (item) {
            const query = {
                parentName: this.parentName || 'examThreeVideoV2Category',
                cityCode: this.cityCode,
                examPlaceBatchId: item.id
            }
            localStorage.setItem('examVideoV2PlaceBatchId', item.id)
            this.$router.replace({ name: 'examThreeVideoV2Video', query })
        },
        // 切换城市
        handleToggleCity (cityCode) {
            if (this.cityCode !== cityCode) {
                localStorage.removeItem('examVideoV2PlaceBatchId')
                this.cityCode = cityCode
                this.getCategory()
            }
        },
        // 获取分类
        getCategory () {
            this.$api.getExamPlaceList({
                subject: 3,
                cityCode: this.cityCode
            }).then(res => {
                if (res.status) {
                    const { examPlaceList, disableMessage, vipSwitchFlag, vipFlag } = res.result
                    if (vipFlag && vipSwitchFlag && disableMessage) {
                        this.messageDialog = {
                            visible: true,
                            rightBtnName: '我知道了',
                            rightBtnMethod: () => {
                                this.messageDialog.visible = false
                            },
                            title: '提示',
                            content: disableMessage
                        }
                    }
                    this.vipSwitchFlag = vipSwitchFlag
                    this.isOpenVip = vipFlag
                    if (examPlaceList && examPlaceList.length) {
                        const arr = []
                        this.currentCategory = examPlaceList.find(({ cityCode }) => (cityCode === this.cityCode)) || examPlaceList[0]
                        this.currentCategory.examPlaceList.forEach(item => {
                            const type = item.vipFlag ? 'unshift' : 'push'
                            arr[type](item)
                        })
                        this.currentCategory.examPlaceList = arr
                        this.categoryItems = examPlaceList
                    }
                } else {
                    Toast(res.message)
                }
            })
        }
    },
    created () {
        this.parentName = this.$route.query.parentName
        this.init()
        this.cityCode = this.$route.query.cityCode || this.$jsBridge.callBackHandler('passRegionCodeData')
        this.getCategory()
    }
}
</script>

<style lang="scss" scoped>
    .wrapper{
        background: #fff;
        .header{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 3;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 44px;
            background: #ffffff;
            .header-main{
                font-size:18px;
                font-family:PingFangSC;
                font-weight:bold;
                color: #333333;
            }
            .header-left,.header-right{
                display: flex;
                padding: 15px 10px;
                width: 24px;
                height: 24px;
                font-size: 0;
                line-height: 1;
                img{
                    width: 24px;
                    height: 24px;
                }
            }
        }
        .header-pre{
            height: 44px;
        }
    }
    .category {
        .tips{
            display: flex;
            align-items: flex-start;
            padding: 5px 15px;
            color: #666;
            background-color: #FEF7EF;
            img {
                margin-top: 2px;
                margin-right: 4px;
                width: 12px;
                height: 12px;
            }
            p {
                flex: 1;
                font-size: 12px;
                line-height: 19px;
            }
        }
        h3 {
            color: #333333;
            font-size: 24px;
            font-weight: 600;
            line-height: 1;
            text-align: center;
        }
        .small {
            margin-top: 10px;
            color: #999;
            font-size: 14px;
            font-weight: 400;
            line-height: 1;
            text-align: center;
        }
        .city {
            padding-top: 20px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            white-space: nowrap;
            &-item{
                margin:0 10px 20px;
                color: #333333;
                font-size: 15px;
                font-weight: 400;
                transition: all 0.5s ease;
                &.active{
                    position: relative;
                    font-weight: 600;
                    transform: scale(1.05);
                    &::after{
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 5px;
                        background: #53CB85;
                        border-radius: 3px;
                    }
                    span{
                        position: relative;
                        z-index: 2;
                    }
                }
            }
        }
        &-wrap {
            padding: 20px;
        }
        &-content {
            display: flex;
            flex-wrap: wrap;
        }
        &-item {
            margin-bottom: 15px;
            position: relative;
            flex: 0 0 calc( 50% - 7.5px );
            height: 100px;
            line-height: 1;
            background: #000000;
            border-radius: 5px;
            overflow: hidden;
            &__bg {
                width: 100%;
                height: 100%;
                vertical-align: middle;
            }
            &__mask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,0.5);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #fff;
            }
            &__name{
                font-weight: 600;
                font-size: 15px;
            }
            &__line{
                margin-top: 5px;
                font-size: 12px;
                span{
                    color: #FF5050;
                }
            }
            &__type{
                position: absolute;
                top: 0;
                right: 0;
                width: 52px;
                height: 16px;
            }
            &:nth-child(odd){
                margin-right: 7.5px;
            }
            &:nth-child(even){
                margin-left: 7.5px;
            }
        }
    }
</style>
